<app-feature-hero
    title="Asset Verification <br> and Audit Solution"
    description="Stay ever-ready for asset audits with our <br> asset verification software."
    image="/assets/img/feature-pages/infraon-assets/asset-verification/msp-asset-management-hero-img-01-01.png"
    imageAlt="Infraon Assets Dashboard"
></app-feature-hero>


<app-feature-row
    headingLevel="h2"
    heading="What is Asset Verification?"
    [paragraphs]="whatIsParagraphs"
    image="/assets/img/feature-pages/infraon-assets/asset-verification/asset-verification-feature-1-01.png"
    imageAlt="Server management and application management"
    imagePosition="right"
></app-feature-row>

<app-feature-row
    headingLevel="h2"
    heading="What does Asset Verification Software do?"
    [paragraphs]="whatDoesItDoParagraphs"
    image="/assets/img/feature-pages/infraon-assets/asset-verification/asset-verification-feature-2-01.png"
    imageAlt="Server management and application management"
    imagePosition="left"
></app-feature-row>
    
<section class="container section-spacing">
    <div class="row mx-0">
        <h2 style="width: 100%;" class="section-title text-center mb-0">Key benefits of Asset Verification Solution</h2>
    </div>
<app-feature-row
    headingLevel="h3"
    heading="Reduce operational costs"
    [paragraphs]="reduceCostsParagraph"
    image="/assets/img/feature-pages/infraon-assets/asset-verification/msp-management-feature-img-2-01.png"
    imageAlt="Server management and application management"
    imagePosition="right"
></app-feature-row>

<app-feature-row
    headingLevel="h3"
    heading="Increased accuracy"
    [paragraphs]="increasedAccuracyParagraph"
    image="/assets/img/feature-pages/infraon-assets/asset-verification/asset-verification-feature-3-01.png"
    imageAlt="hardware asset management"
    imageStyle="box-shadow: none"
    imagePosition="left"
></app-feature-row>

<app-feature-row
    headingLevel="h3"
    heading="Enhanced security"
    [paragraphs]="enhancedSecurityParagraph"
    image="/assets/img/feature-pages/infraon-assets/asset-verification/asset-verification-feature-4-01.png"
    imageAlt="Server management and application management"
    imagePosition="right"
></app-feature-row>
    
<app-feature-row
    headingLevel="h3"
    heading="Improved operational efficiency"
    [paragraphs]="improvedEfficiencyParagraph"
    image="/assets/img/feature-pages/infraon-assets/asset-verification/equipment-maintenance-software-feature-06-01.svg"
    imageAlt="hardware asset management"
    imageStyle="box-shadow: none"
    imagePosition="left"
></app-feature-row>

</section>
    
<section class="container section-spacing">
    <div class="row mx-0">
        <h2 style="width: 100%;" class="section-title text-center mb-0">Using Infraon's Asset Verification Solution</h2>
    </div>
<app-feature-row
    headingLevel="h3"
    heading="Identify and track asset location"
    [paragraphs]="identifyLocationParagraph"
    image="/assets/img/feature-pages/infraon-assets/asset-verification/asset-verification-feature-5-01.png"
    imageAlt="Server management and application management"
    imagePosition="right"
></app-feature-row>

<app-feature-row
    headingLevel="h3"
    heading="Get asset audit reports"
    [paragraphs]="auditReportsParagraph"
    image="/assets/img/feature-pages/infraon-assets/asset-verification/asset-verification-feature-6-01.png"
    imageAlt="hardware asset management"
    imageStyle="box-shadow: none"
    imagePosition="left"
></app-feature-row>

<app-feature-row
    headingLevel="h3"
    heading="Centralized dashboard"
    [paragraphs]="centralizedDashboardParagraph"
    image="/assets/img/feature-pages/infraon-assets/asset-verification/equipment-maintenance-software-feature-09-01.svg"
    imageAlt="Server management and application management"
    imagePosition="right"
></app-feature-row>
    
<app-feature-row
    headingLevel="h3"
    heading="Get actionable insights"
    [paragraphs]="actionableInsightsParagraph"
    image="/assets/img/feature-pages/infraon-assets/asset-verification/asset-verification-feature-7-01.png"
    imageAlt="Asset verification feature."
    imageStyle="box-shadow: none"
    imagePosition="left"
></app-feature-row>

</section>
    
<section class="section-spacing primary-bg trial-now">
    <div class="container">
        <h2 class="section-title text-center text-white"><span class="text-lowercase">How about a free trial with NO credit card required?</span></h2>

        <div class="d-flex justify-content-center">
            <a routerLink="/it-asset-management/prices/assets-pricing" class="secondary-button bg-white" style="margin: auto;color: var(--title);">Start now</a>
        </div>
    </div>
</section>

<section class="section-spacing bg-grey">
    <div class="container">
        <h2 class="section-title text-center">Related Content</h2>

        <div class="row mx-0">
            <div class="col-xl-4 col-lg-4 col-md-12 col-sm-12 col-xs-12 m-margin-bottom">
                <a routerLink="/it-asset-management/features/it-assets-management-solutions">
                    <div class="backlink-container bg-white h-100">
                        <p class="section-title-s text-start">
                            IT asset management
                        </p>
                        <p class="section-paragraph-s text-start">
                            Infraon IT Asset Lifecycle Management offers a centralized, low-code platform to optimize your IT asset usage. Make smart purchasing...
                        </p>
                        <p class="primary-color mb-0">Know more</p>
                    </div>
                </a>
            </div>
            <div class="col-xl-4 col-lg-4 col-md-12 col-sm-12 col-xs-12 m-margin-bottom">
                <a routerLink="/it-asset-management/features/software-assets-management-solutions">
                    <div class="backlink-container bg-white h-100">
                        <p class="section-title-s text-start">
                            Software asset management
                        </p>
                        <p class="section-paragraph-s text-start">
                            Infraon IT Asset Lifecycle Management offers a centralized, low-code platform to optimize your IT asset usage. Make smart purchasing...
                        </p>
                        <p class="primary-color mb-0">Know more</p>
                    </div>
                </a>
            </div>
            <div class="col-xl-4 col-lg-4 col-md-12 col-sm-12 col-xs-12">
                <a routerLink="/it-asset-management/features/software-license-management">
                    <div class="backlink-container bg-white h-100">
                        <p class="section-title-s text-start">
                            Software Licensing management
                        </p>
                        <p class="section-paragraph-s text-start">
                            Infraon Assets helps you manage the lifecycles of fixed assets like PCs, laptops, furniture, storage devices, etc., with a 360-degree view...
                        </p>
                        <p class="primary-color mb-0">Know more</p>
                    </div>
                </a>
            </div>
        </div>
    </div>
</section>


<section class="container section-spacing" id="success-stories">
    <h2 class="section-title p-b-60 text-center">Success Stories</h2>
    <div class="row mx-0 d-flex justify-content-center">
        <div class="col-xl-4 col-lg-4 col-md-12 col-sm-12 col-xs-12">
            <div class="border p-4 radius-10 h-100">
                <img src="/assets/img/feature-pages/ask-01.svg" class="d-block" style="min-height: 50px;" alt="ASK FRAS-LE FRICTION PVT. LTD. Logo">
                <div>
                    <p class="section-title-s text-start">
                        ASK FRAS-LE FRICTION PVT. LTD.
                    </p>
                    <p class="section-paragraph-s text-start">
                        Infraon Optimized Operations with 75% Improvement in Productivity &amp; Compliance
                    </p>
                </div>
                <a [routerLink]="['/resources/', 'case-studies', 'ask-fras-le-friction']" class="primary-color crmform-button mt-0">View Case Study</a>
            </div>
        </div>
        
        <div class="col-xl-4 col-lg-4 col-md-12 col-sm-12 col-xs-12">
            <div class="border p-4 radius-10 h-100">
                <img src="/assets/img/feature-pages/sea-infronet-01.svg" class="d-block" style="min-height: 50px;" alt="SEA Infonet Pvt. Ltd. Logo">
                <div>
                    <p class="section-title-s text-start">
                        SEA Infonet Pvt. Ltd.
                    </p>
                    <p class="section-paragraph-s text-start">
                        SEA Infonet's Success on Ticket Management with Infraon ITSM
                    </p>
                </div>
                <a [routerLink]="['/resources/', 'case-studies', 'sea-infonet']" class="primary-color crmform-button mt-0">View Case Study</a>
            </div>
        </div>
    </div>
</section>